export const DETAILS = {
    name: " ساچ باربر",
    shortName: "ساچ باربر",
    footerName: "ساچ باربر",
    description: "",
    shortAbout: "فروشگاه سلنا بزرگترین و معتبرترین فروشگاه لباس زیر در شهر کرج می باشد که هم به صورت حضوری و هم فروش آنلاین فعالیت گسترده ای دارد. در فروشگاه سلنا، بهترین برندهای لباس زیر موجود در بازار در دسترس مشتریان قرار دارند. کیفیت، زیبایی و راحتی لباس زیرهای سلنا آن چیزیست که رضایت مشتریان ما را همواره جلب کرده است.",
    veryShortAbout: "فروشگاه سلنا بزرگترین و معتبرترین فروشگاه لباس زیر در شهر کرج می باشد که هم به صورت حضوری و هم فروش آنلاین فعالیت گسترده ای دارد. در فروشگاه سلنا، بهترین برندهای لباس زیر موجود در بازار در دسترس مشتریان قرار دارند. کیفیت، زیبایی و راحتی لباس زیرهای سلنا آن چیزیست که رضایت مشتریان ما را همواره جلب کرده است.",
    link: "https://sachbarber.com",
    mobile: [
        "09104623623",
        "09198187284",
    ],
    phone: [],
    email: [],
    postalCode: [],
    address:"کرج بلوار رستاخیر نبش خیابان نهم",
    supportDescription: "",
    workingHours: ["شنبه تا پنجشنبه 10 تا 13 و 16:30 تا 21", "جمعه 17 تا 21"],
    mapIframeSrc: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3233.6340923530356!2d50.97366812391697!3d35.857974837060326!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzXCsDUxJzI5LjkiTiA1MMKwNTgnMjIuOSJF!5e0!3m2!1sfa!2s!4v1747634549867!5m2!1sfa!2s",
    socialMedia: [
        {
            title: 'واتس اپ',
            value: '09198187284',
            name: 'whatsapp',
            link: 'https://api.whatsapp.com/send/?phone=989198187284&text&app_absent=0',
            icon: <i className="lab la-whatsapp"/>,
            isPrimary: true
        },
     /*   {
            title: 'تلگرام',
            value: '09120561620',
            name: 'telegram',
            link: 'https://t.me/+989120561620',
            icon: <i className="lab la-telegram-plane"/>,
            isPrimary: true
        },*/
        {
            title: 'اینستاگرام',
            value: 'sachbarber',
            name: 'instagram',
            link: "https://instagram.com/sachbarber",
            icon: <i className="lab la-instagram"/>,
            isPrimary: true
        },
        /*{
                    title: 'ایتا',
                    value: '09357195494',
                    name: 'eitaa',
                    link: 'https://eitaa.com/09357195494',
                    icon: <img src={eitaaIcon} alt='ایتا'/>,
                    isPrimary: false
                }
        {
            title: 'ایمیل',
            value: 'Volvotak@gmail.com',
            name: 'email',
            link: 'mailto:Volvotak@gmail.com',
            icon: <i className="las la-envelope"></i>,
            isPrimary: true
        },
        {
            title: 'تس',
            value: '09133377432',
            name: 'phone',
            link: 'tel:989133377432',
            icon: <PhoneCall/>,
            isPrimary: true
        },
                /*{
                    title: 'آپارات',
                    value: 'Alo_aghsat',
                    name: 'aparat',
                    link: 'https://www.aparat.com/Alo_aghsat',
                    icon: <SiAparat size={25}/>,
                    isPrimary: true
                },
                {
                    title: 'تماس',
                    value: '02636634893',
                    name: 'phone',
                    link: 'tel:+982636634893',
                    icon: <PhoneCall/>,
                    isPrimary: false
                },
                {
                    title: 'سروش پلاس',
                    value: '09331074475',
                    name: 'soroushPlus',
                    link: '',
                    icon: <img src={soroushIcon} alt='سروش'/>,
                    isPrimary: false
                },
                {
                    title: 'سروش پلاس',
                    value: '09332094475',
                    name: 'soroushPlus',
                    link: '',
                    icon: <img src={soroushIcon} alt='سروش'/>,
                    isPrimary: false
                },
                {
                    title: 'سروش پلاس',
                    value: '09330324475',
                    name: 'soroushPlus',
                    link: '',
                    icon: <img src={soroushIcon} alt='سروش'/>,
                    isPrimary: false
                },
                {
                    title: 'ایتا',
                    value: '09331074475',
                    name: 'eitaa',
                    link: '',
                    icon: <img src={eitaaIcon} alt='ایتا'/>,
                    isPrimary: false
                },*/
    ],
    services: [],
    brands: [
        /*{
            name: 'Apple',
            image: <img src={appleImage} alt='apple'/>,
        },*/
    ],
    "enamadLink": "https://trustseal.enamad.ir/?id=518940&Code=iX7BkN9RR3hlEQLxaeWaHByNrsfWj1fK",
    "enamadImageLink" :"https://trustseal.enamad.ir/logo.aspx?id=518940&Code=iX7BkN9RR3hlEQLxaeWaHByNrsfWj1fK",
    "enamadCode" : "iX7BkN9RR3hlEQLxaeWaHByNrsfWj1fK",
    "samandehiLink": "",
    "ZarinpalLink": "https://www.zarinpal.com/webservice/TrustCode"
}
